import axios from 'axios'
import store from '@/store/index'

const instance = axios.create({
  baseURL: store.getters['localSettings/clientAppUrl'],
  headers: {
    'Content-Type': 'application/json'
  }
})

export default instance



// WEBPACK FOOTER //
// ./src/services/api/localApi.js